import { Tag, Typography } from 'antd';
import styled from 'styled-components';

const { Text, Title } = Typography;

export const DrawerBody = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const HeaderInfo = styled.div`
  margin-bottom: 12px;
`;

export const Content = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 4px 0;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(300px, 1fr));
  gap: 12px;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;

export const FieldBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Label = styled(Text)`
  font-size: 12px;
  color: #666;
`;

export const FullWidth = styled.div`
  grid-column: 1 / -1;
`;

export const SectionTitle = styled(Title)`
  margin-top: 16px !important;
  margin-bottom: 10px !important;
`;

export const OrderItemCard = styled.div`
  background: #fff3e0;
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const SerialTag = styled(Tag)`
  margin-bottom: 8px;
  cursor: pointer;
  user-select: none;
`;

export const Footer = styled.div`
  border-top: 1px solid #f0f0f0;
  padding-top: 12px;
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const SelectionCard = styled.div`
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 10px;
`;

export const LinkedOrdersSection = styled.div`
  margin-bottom: 16px;
  padding: 12px;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  background: #fafafa;
`;

export const LinkedOrdersHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const LinkedOrdersCount = styled.span`
  min-width: 24px;
  height: 24px;
  padding: 0 8px;
  border-radius: 999px;
  background: #e6f4ff;
  color: #0958d9;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const LinkedOrdersList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const LinkedOrderItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 10px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background: #ffffff;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const LinkedOrderMain = styled.div`
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
`;

export const LinkedOrderLink = styled.a`
  color: #1f2937;
  font-weight: 600;

  &:hover {
    color: #1677ff;
  }
`;

export const ReplacementItemsHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 6px 0;
`;

export const ReplacementItemRow = styled.div`
  display: grid;
  grid-template-columns: 2fr 2fr 1fr auto;
  gap: 8px;
  margin-bottom: 8px;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;
